import React from 'react';

// Five-point star centred on (cx, cy), outer radius r.
const star = (cx, cy, r) => Array.from({ length: 10 }, (_, i) => {
  const a = (Math.PI / 5) * i - Math.PI / 2;
  const d = i % 2 ? r * 0.382 : r;
  return `${(cx + d * Math.cos(a)).toFixed(2)},${(cy + d * Math.sin(a)).toFixed(2)}`;
}).join(' ');

/** The Syrian flag: green / white with three red stars / black.
 *  Drawn, never the 🇸🇾 emoji — device emoji fonts show the old flag. */
export function SyriaFlag({ size = 16 }) {
  return (
    <svg width={size * 1.5} height={size} viewBox="0 0 30 20" role="img" aria-label="سوريا"
      style={{ verticalAlign: '-0.15em', borderRadius: 2, boxShadow: '0 0 0 1px rgba(0,0,0,.12)' }}>
      <rect width="30" height="20" fill="#fff" />
      <rect width="30" height="6.67" fill="#007a3d" />
      <rect y="13.33" width="30" height="6.67" fill="#000" />
      {[7.5, 15, 22.5].map((x) => <polygon key={x} points={star(x, 10.2, 2.6)} fill="#ce1126" />)}
    </svg>
  );
}

/** Flag of a COUNTRIES entry (ui/phone.js). */
export default function CountryFlag({ country, size }) {
  if (!country) return null;
  if (country.code === '963') return <SyriaFlag size={size} />;
  return <span aria-hidden="true">{country.flag}</span>;
}
